import clsx from 'clsx'
import React, { FC } from "react"

import { ActionButtonProps } from "../../utils/Interfaces"
import { SpinnerIcon } from '../../resources/icons/SpinnerIcons';

export const ActionButton: FC<ActionButtonProps> = ({ posting, actionName, callback, type = "button", variant = "primary" }) => {

    // Style Mapping for Branding
    const variantStyles = {
        primary: "bg-orange-500 border disabled:bg-orange-400 text-white hover:bg-orange-600 border-transparent focus:ring-orange-500 shadow-sm",
        outline: "bg-transparent border border-orange-500 text-orange-600 hover:bg-transparent hover:text-orange-700 hover:border-orange-600 focus:ring-orange-500 shadow-sm",
        ghost: "bg-transparent hover:bg-orange-50 border-none text-orange-600 hover:text-orange-700 focus:ring-orange-500"
    };

    return (
        <React.Fragment>
            <button type={type} onClick={callback} className={clsx(
                variantStyles[variant],
                "w-auto min-w-20 flex gap-2 justify-center disabled:cursor-not-allowed text-sm rounded-md px-2.5 py-1.5 focus:outline-none"
            )} disabled={posting} aria-busy={posting} aria-live="polite">
                {
                    posting ? (
                        <span className="flex items-center justify-center">
                            <SpinnerIcon />
                            <span className="sr-only">Processing...</span>
                        </span>
                    ) : (
                        actionName
                    )
                }
            </button>
        </React.Fragment>
    )
}